import { Form } from "antd";
import React from "react";
import DataGrid from "../../../core/ui/components/grid/DataGrid";
import DataGridConfigurationBuilder from "../../../core/ui/components/grid/DataGridConfigurationBuilder";
import TickBox from "../../../core/ui/components/grid/TickBox";
import { IIndexTypeCategory } from "../../model/IndexTypeCategory";
import IndexTypeCategoryForm from "./IndexTypeCategoryForm";

interface IndexTypeCategoriesGridProps {
  translate: any;
  createIndexTypeCategory: any;
  referenceLoader?: boolean;
  indexTypeCategories: IIndexTypeCategory[];
  showDetails: (id: number) => void;
  updateIndexTypeCategory: any;
  findConnectionCandidates: any;
  categoryCandidates: IIndexTypeCategory[];
  showBulkEditor(id: number): void;
  toggleCandidate: any;
}
const IndexTypeCategoryGrid: React.FC<IndexTypeCategoriesGridProps> = ({
  translate,
  createIndexTypeCategory,
  referenceLoader,
  indexTypeCategories,
  showDetails,
  updateIndexTypeCategory,
  findConnectionCandidates,
  categoryCandidates,
  showBulkEditor,
  toggleCandidate
}) => {
  const builder = DataGridConfigurationBuilder({
    translate,
    resourcePrefix: "editors.index_type_categories"
  });
  const columns = builder.buildColumns(
    "code",
    "name",
    "description",
    {
      name: "valid",
      dataKey: "valid",
      sortable: false,
      align: "center",
      render: (record) => <TickBox value={record.valid} />
    },
    {
      name: "typeDetails",
      dataKey: "typeDetails",
      sortable: false,
      align: "center",
      render: (record) => (
        <button
          type="button"
          className="ant-btn ant-btn-link ant-btn-sm"
          onClick={() => showDetails(record.id)}
        >
          <span>{translate("editors.index_type_categories.details")}</span>
        </button>
      )
    }
  );

  const [CreateForm] = Form.useForm();
  const [UpdateForm] = Form.useForm();

  return (
    <DataGrid
      childrenColumnName={"groups"}
      title={translate("editors.index_type_categories.title")}
      columns={columns}
      translate={translate}
      dataSource={indexTypeCategories}
      allowCreate={true}
      allowUpdate={true}
      addButtonText={translate("editors.index_type_categories.add_new_text")}
      createForm={
        <IndexTypeCategoryForm translate={translate} form={CreateForm} />
      }
      updateForm={
        <IndexTypeCategoryForm
          translate={translate}
          form={UpdateForm}
          categoryCandidates={categoryCandidates}
          toggleCandidate={toggleCandidate}
        />
      }
      onStartUpdate={(category) => {
        findConnectionCandidates(category);
      }}
      createModalTitle={`${translate(
        "editors.index_type_categories.create_modal_title"
      )}`}
      loading={referenceLoader}
      onCreate={(e) => {
        createIndexTypeCategory(e);
      }}
      onUpdate={(e) => {
        updateIndexTypeCategory(e);
      }}
      booleanColumnKeys={["valid"]}
      createModalClass={"modal-width"}
      updateModalClass={"modal-width"}
      keyProperty={"id"}
      CreateFormInstance={CreateForm}
      UpdateFormInstance={UpdateForm}
      createActionPosition={"topRight"}
      actions={[
        {
          id: "bulk-edit",
          label: "Masovno uređivanje",
          type: "text",
          onClick: (record) => {
            return (e) => {
              showBulkEditor(record.id);
            };
          }
        }
      ]}
    />
  );
};
export default IndexTypeCategoryGrid;
